import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit'
import { DeclarationWrapper, LineJump, StrongSpam } from './SendSellerQuoteDialog.styles'

const { bool } = PropTypes

const SendSellerQuoteDialogListText = ({ showAbilityAffidavit }) => (
  <DeclarationWrapper>
    <Typography fontSize="16px" fontWeight="bold" lineHeight="26px" variant="h3">
      Declaración Jurada de Requisitos para Ofertar
      <LineJump />
      <LineJump />
    </Typography>
    <Typography fontWeight="light" variant="body2" align="justify">
      1.- No estoy condenado,{' '}
      <StrongSpam>
        <em>mediante sentencia judicial firme o ejecutoriada,</em>
      </StrongSpam>{' '}
      a la sanción de inhabilidad para formar parte del Registro de Proveedores, de conformidad con lo establecido en el
      artículo 35 septies, con ocasión de una condena por prácticas antisindicales o infracción a los derechos
      fundamentales del trabajador.
      <LineJump />
      <LineJump />
      2.- No he sido condenado, o mi representada no ha sido condenada, por el Tribunal de Defensa de la Libre
      Competencia, dentro de los 5 años anteriores, contados desde que la sentencia definitiva quede ejecutoriada, con
      la prohibición de contratar a cualquier título con órganos de la administración, contemplada en el artículo 26,
      letra d), del Decreto con Fuerza de Ley N°1, de 2004, del Ministerio de Economía, Fomento y Reconstrucción, que
      Fija el texto refundido, coordinado y sistematizado del decreto ley N°211, de 1973.
      <LineJump />
      <LineJump />
      3.- Mi representada no ha sido condenada a la pena de prohibición de celebrar actos y contratos con organismos del
      Estado, por los delitos mencionados en la ley N°20.393.
      <LineJump />
      <LineJump />
      4.- No he sido condenado por los Tribunales de Justicia a la medida dispuesta en el artículo 33 de la ley N°21.595
      de Delitos Económicos. En el caso de que mi representada sea una persona jurídica, ya sea que se trate de
      sociedades, fundaciones o corporaciones, declaro que esta no tiene como socio, accionista, miembro o partícipe con
      poder para influir en la administración, a personas naturales que hubieran sido condenadas a la citada medida.
      <LineJump />
      <LineJump />
      5.- No soy ni he sido durante el período de un año transcurrido con antelación a la presente declaración,
      funcionario directivo del organismo licitante y/o comprador, hasta el nivel de jefe de departamento o su
      equivalente, o funcionario que participe en procedimientos de contratación del organismo licitante y/o comprador,
      ni estoy unido(a) a éstos o aquéllos por los vínculos descritos en la letra b) del artículo 54 de la ley N°18.575
      (cónyuge, hijo, adoptado o pariente hasta el tercer grado de consanguinidad y segundo de afinidad inclusive).
      <LineJump />
      <LineJump />
      6.- No integro la nómina de personal del organismo licitante y/o comprador, en cualquier calidad jurídica, ni soy
      contratado a honorarios por el organismo licitante y/o comprador, ni estoy unido(a) a éstos o aquéllos por los
      vínculos descritos en el inciso primero del artículo 35 quáter de la ley N°19.886 (cónyuge, convivientes civil o
      pariente hasta el segundo grado de consanguinidad o afinidad).
      <LineJump />
      <LineJump />
      7.- Mi representada no es una sociedad de personas, empresa individual de responsabilidad limitada, sociedad en
      comandita por acciones o anónima cerrada en la que una o más de las personas singularizadas en los párrafos quinto
      y sexto precedentes formen parte o sean beneficiarias finales o una sociedad anónima abierta en que tales personas
      sean dueñas de acciones que representen el 10% o más del capital o sean beneficiarias finales.
      <LineJump />
      <LineJump />
      8.- No soy gerente, administrador, representante o director de cualquiera de las sociedades antedichas.
      <LineJump />
      <LineJump />
    </Typography>
    {showAbilityAffidavit && (
      <>
        <LineJump />
        <Typography fontWeight="light" variant="body2" align="justify">
          Declaro que toda la información ingresada en este formulario es veraz, completa, verificable y se encuentra
          actualizada. Debe tenerse presente que faltar a la verdad respecto de lo informado en una declaración jurada
          puede traducirse en la comisión del delito de perjurio, en virtud del artículo 210 del Código Penal, que
          dispone que 'el que ante la autoridad o sus agentes perjurare o diere falso testimonio en materia que no sea
          contenciosa, sufrirá las penas de presidio menor en sus grados mínimo a medio y multa de seis a diez unidades
          tributarias mensuales.'
        </Typography>
      </>
    )}
  </DeclarationWrapper>
)

SendSellerQuoteDialogListText.propTypes = {
  showAbilityAffidavit: bool.isRequired
}

export default SendSellerQuoteDialogListText
